import React from 'react';
import { Box, } from '@mui/material';
import toast from 'react-hot-toast';
import axiosInstant from '../../../api';
import UserEditForm from './form';
import { MainContainer } from '../../../components/ContentWrapper';

const AdminCreateUser = () => {
  const handleSubmit = async (values: any, actions: any) => {
    try {
      await axiosInstant.post('/admin/users', values);
      actions.setSubmitting(false);
      toast.success('New user created successfully.', { duration: 3000 });
    } catch (error: any) {
      const errorMessage = error?.response?.data;
      if (errorMessage === 'EmailAlreadyExists') {
        toast.error('A user with this email already exists.');
      } else {
        toast.error('Failed to create user. Please try again.');
      }
      actions.setSubmitting(false);
    }
  };

  return (
    <MainContainer title="create user">
      {/* main content */}
      <Box
        sx={{
          p: { xs: 2, sm: 3, md: 4 },
          backgroundColor: 'var(--surface)',
          borderRadius: { xs: 2, sm: 4 },
        }}
      >
        <UserEditForm handleSubmit={handleSubmit} />
      </Box>
    </MainContainer>
  );};

export default AdminCreateUser;
